module.exports = __webpack_public_path__ + "static/media/tv-alt.34378a52.svg";